// ----- NodeList forEach polyfill for ie
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

// ----- Imports
import { alert } from './alerts';
import { enquireForm } from './forms';
import { blockHeroBgImage } from './hero-images';
import { blockHeroHomeBgImage, syncLinkList } from './hero-home-page';
import { initTypeKit, equalHeightInit, srcsetBG } from './utils';
import { initModal, enquireFormModal, phoneModal } from './modals';
import { comparisonTable, serviceSearch } from './pages';
import { depthIllustrations } from './depth-illustrations';
import { callOutBlock, dismissibleContent } from './flexible-layouts';
import { latestService, latestServiceType, latestLocation } from './cookies-localstorage';
import { serviceFinderInit } from './service-finder';
import { contactPopupInit } from './contact-popup';
import { singleServiceSearchRefresh } from './single-service-intro';
import { jobListFilterInit } from './job_listings';
import { collapsibleInit } from './collapsible.js';
import { scrollGradientInit } from './scroll-gradient.js';
import { horizontalScrollInit } from './horizontal-scroll';
import { headerInit } from './header';
import { comparisonTableInit } from './comparison-table';

/**
 * On document ready
 */
document.addEventListener('DOMContentLoaded', function() {
    alert();
    initTypeKit();
    headerInit();
    blockHeroBgImage();
    blockHeroHomeBgImage();
    latestService();
    latestServiceType();
    latestLocation();
    serviceSearch();
    equalHeightInit();
    initModal();
    enquireFormModal();
    comparisonTable();
    enquireForm();
    dismissibleContent();
    contactPopupInit();
    singleServiceSearchRefresh();
    srcsetBG();
    setTimeout(phoneModal,3000);
    jobListFilterInit();
    collapsibleInit();
    scrollGradientInit();
    syncLinkList();
    horizontalScrollInit();
    comparisonTableInit();
});

window.addEventListener('load', callOutBlock);
window.addEventListener('load', equalHeightInit);
window.addEventListener('load', depthIllustrations);
window.addEventListener('load', serviceFinderInit);

window.addEventListener('resize', callOutBlock);
window.addEventListener('resize', equalHeightInit);
window.addEventListener('resize', collapsibleInit);



// WEBPACK FOOTER //
// ./src/js/custom.js